import { getBFFApiClient } from '@acp/feature/auth';
import { APIResponse, ServiceSheetData } from '@acp/shared';
import HttpStatusCodes from 'http-status-codes';
import { NotificationSummary, PaginatedNotifications } from './types';

const DEFAULT_PAGE_SIZE = 20;

async function getNotifications(
    cursor?: string,
    pageSize: number = DEFAULT_PAGE_SIZE
): Promise<PaginatedNotifications> {
    const response = await getBFFApiClient().get<APIResponse<PaginatedNotifications>>('/v1/notifications', {
        params: {
            ...(cursor !== undefined && { cursor }),
            page_size: pageSize,
        },
    });

    if (response.status !== HttpStatusCodes.OK || !response.data.success) {
        throw new Error(`Failed to get notifications: ${response.data.error}`);
    }

    return response.data.data;
}

async function getNotificationSummary(): Promise<NotificationSummary> {
    const response = await getBFFApiClient().get<APIResponse<NotificationSummary>>('/v1/notifications/summary');

    if (response.status !== HttpStatusCodes.OK || !response.data.success) {
        throw new Error(`Failed to get notification summary: ${response.data.error}`);
    }

    return response.data.data;
}

async function acknowledge(): Promise<void> {
    const response = await getBFFApiClient().post<APIResponse<{ count: number }>>('/v1/notifications/acknowledge');

    if (response.status !== HttpStatusCodes.OK || !response.data.success) {
        throw new Error(`Failed to acknowledge notifications: ${response.data.error}`);
    }
}

async function markAsRead(id: string): Promise<void> {
    const response = await getBFFApiClient().post<APIResponse<null>>(`/v1/notifications/${id}/mark-as-read`);

    if (response.status !== HttpStatusCodes.OK || !response.data.success) {
        throw new Error(`Failed to mark notification as read: ${response.data.error}`);
    }
}

async function markAllAsRead(): Promise<void> {
    const response = await getBFFApiClient().post<APIResponse<null>>('/v1/notifications/mark-all-read');

    if (response.status !== HttpStatusCodes.OK || !response.data.success) {
        throw new Error(`Failed to mark all notifications as read: ${response.data.error}`);
    }
}

async function getServiceSheetById(
    serviceSheetId: number
): Promise<ServiceSheetData> {
    const response = await getBFFApiClient().get<APIResponse<ServiceSheetData>>(
        `/v1/service-report/service-sheet/${serviceSheetId}`
    );

    if (response.status !== HttpStatusCodes.OK || !response.data.success) {
        throw new Error(`Failed to get service sheet: ${response.data.error}`);
    }

    return response.data.data;
}

export {
    getNotifications,
    getNotificationSummary,
    acknowledge,
    markAsRead,
    markAllAsRead,
    getServiceSheetById,
};
